import { render } from "./motion-content.vue?vue&type=template&id=64cf5dad"
import script from "./motion-content.vue?vue&type=script&lang=js"
export * from "./motion-content.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__